import lodashIsNumber from "lodash/fp/isNumber";
import lodashIsString from "lodash/fp/isString";
import { notification_event_type } from "prisma-generated/enums";
import type {
  WebsocketNotificationEvent,
  MessageNotificationMetadata,
} from "shared/types/notification-event";

export type PushNotificationWebsocketEvent = WebsocketNotificationEvent & {
  eventType: typeof notification_event_type.push_notification;
};

export const isNotificationMessage = (
  message: WebsocketNotificationEvent,
): message is PushNotificationWebsocketEvent => {
  return (
    message.eventType === notification_event_type.push_notification &&
    lodashIsString(message?.notification?.title) &&
    lodashIsString(message?.notification?.body)
  );
};

export type MessageNotificationWebsocketEvent = WebsocketNotificationEvent & {
  eventType: typeof notification_event_type.message_notification;
  messageNotificationMetadata: MessageNotificationMetadata;
};

export const isChatMessage = (
  message: WebsocketNotificationEvent,
): message is MessageNotificationWebsocketEvent => {
  return (
    message.eventType === notification_event_type.message_notification &&
    lodashIsString(message?.notification?.title) &&
    lodashIsString(message?.notification?.body) &&
    lodashIsNumber(message?.messageNotificationMetadata?.chatId)
  );
};
